import React, { Component } from "react";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import { Table } from "workbench";
import classNames from "classnames";
import pageStyles from "../../../styles/App.module.scss";
import PageLoadingWithTable from "../../common/PageLoadingWithTable";
import { bindDispatch, modifyTableColumns } from "../../../utils";
import Breadcrumb from "../../common/BreadCrumb";
import PageHeader from "../../common/PageHeader";
import HeaderButton from "../../common/HeaderButtons";

const columns = [
  {
    id: "position",
    Header: "Order",
    width: 100,
    accessor: "position",
  },
  {
    id: "code",
    Header: "Code",
    accessor: "code",
  },
  {
    id: "name",
    Header: "Name",
    accessor: "name",
  },
];
const links = [
  { name: "PageHeader.lists", path: "/lists" },
  { name: "PageHeader.playlistPackTypes" },
];

export class PlaylistPackTypes extends Component {
  state = {
    selectedColumns: ["Code", "Name", "Order"],
  };

  componentDidMount = () => {
    this.props.actions.getPlaylistPackTypes();
  };

  onColumnSelect = (selectedColumns, reorderedColumns) =>
    this.setState({ selectedColumns, reorderedColumns });

  render = () => {
    const {
      playlistPackTypes: { list = [], isLoading = false },
      history,
    } = this.props;

    if (isLoading) return <PageLoadingWithTable showBreadcrumb={true} tableRowsCount={10} />;

    const { selectedColumns, reorderedColumns } = this.state;
    return (
      <div className="col-12 clearfix">
        <Breadcrumb history={history} links={links} />
        <PageHeader
          isLoading={isLoading}
          name="PageHeader.playlistPackTypes"
          count={list.length}
          renderRightSideComponent={() => (
            <HeaderButton
              columnFilter
              columns={columns}
              selectedColumns={selectedColumns}
              reorderedColumns={reorderedColumns}
              onColumnFilterSelect={this.onColumnSelect}
            />
          )}
        />
        <div className={pageStyles.pageContainer}>
          <div className={classNames("col-12 clearfix", pageStyles.pageWrapper)}>
            <Table
              pageSize={list.data.length}
              sortable={false}
              data={list.data}
              loading={isLoading}
              columns={modifyTableColumns(columns, selectedColumns, reorderedColumns)}
            />
          </div>
        </div>
      </div>
    );
  };
}

const mapStateToProps = createSelector(
  (state) => state.playlistPackTypes,
  (playlistPackTypes) => ({ playlistPackTypes })
);

export default connect(mapStateToProps, bindDispatch)(PlaylistPackTypes);
